export function useTextInput({ invalid, shrinkLabel }) {
    const inputColor = invalid ? 'error' : undefined;
    const inputLabelProps = {
        shrink: shrinkLabel,
        style: { color: 'white' },
    };
    const sx = { input: { color: 'white' } };
    return {
        inputColor,
        inputLabelProps,
        sx,
    };
}
